import { render, staticRenderFns } from "./EndorseApplication.vue?vue&type=template&id=50b4d2d3&scoped=true"
import script from "./EndorseApplication.vue?vue&type=script&lang=js"
export * from "./EndorseApplication.vue?vue&type=script&lang=js"
import style0 from "./EndorseApplication.vue?vue&type=style&index=0&id=50b4d2d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b4d2d3",
  null
  
)

export default component.exports